import { Component, OnInit } from '@angular/core';
import { ModalNavigationComponent } from '../../modal/modal-navigation-component';
import { ModalNavigationService } from '../../modal/modal-navigation.service';

@Component({
  selector: 'changelog-modal',
  templateUrl: './changelog-modal.component.html',
  styleUrls: ['./changelog-modal.component.scss'],
  standalone: false,
})
export class ChangelogModalComponent implements OnInit, ModalNavigationComponent {
  isInModalContext: boolean;

  title: string;
  subTitle: string;
  branch: string;
  revision: string;
  changeLog: string[];

  constructor(private modalNavigation: ModalNavigationService) {}

  ngOnInit() {
    if (this.isInModalContext) {
      if (this.modalNavigation.getCurrentNavigation().data) {
        const data = this.modalNavigation.getCurrentNavigation().data;
        this.title = data.title;
        this.subTitle = data.subTitle;
        this.branch = data.branch;
        this.revision = data.revision;
        this.changeLog = data.changeLog;
      }
    }
  }
}
